var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col d-flex justify-content-center m-3"},[_c('coozzy-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }